import { render, staticRenderFns } from "./diaposedialog.vue?vue&type=template&id=b3a15526&scoped=true"
import script from "./diaposedialog.vue?vue&type=script&lang=js"
export * from "./diaposedialog.vue?vue&type=script&lang=js"
import style0 from "./diaposedialog.vue?vue&type=style&index=0&id=b3a15526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a15526",
  null
  
)

export default component.exports